<template>
  <gl-field v-bind="$props" :is-active="isActive">
    <template #default="{ innerId }">
      <input
        :id="innerId"
        :value="value"
        :type="type"
        :disabled="disabled"
        :max="maxValue"
        :min="minValue"
        :placeholder="placeholder"
        maxlength="256"
        class="plc-field__input"
        @input="handleChange"
        @focus="handleFocus"
        @blur="handleBlur"
      />
    </template>

    <template #icon>
      <slot name="icon" />
    </template>
    <template v-if="symbol" #symbol>
      <span class="plc-field__symbol">{{ symbol }}</span>
    </template>
    <template #below-field>
      <slot name="below-field" />
    </template>
  </gl-field>
</template>

<script>
import GlField from '@gl/GlField'

export default {
  name: 'GlFieldInput',
  components: {
    GlField,
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    maxValue: {
      type: [String, Number],
      default: null,
    },
    minValue: {
      type: [String, Number],
      default: 0,
    },
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    symbol: {
      type: String,
      default: '',
    },
    tip: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    required: {
      type: Boolean,
    },
    withBorder: {
      type: Boolean,
      default: true,
    },
    debounce: {
      type: Number,
      default: 0,
    },
    isShort: Boolean,
  },
  data() {
    return {
      isActive: false,
      debounceTimer: null,
    }
  },
  methods: {
    handleChange(event) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.$emit('input', event.target.value)
      }, this.debounce)
    },
    handleFocus() {
      this.$emit('focus')
      this.isActive = true
    },
    handleBlur() {
      this.$emit('blur')
      this.isActive = false
    },
  },
}
</script>
